
import {
  Vue, Component,
} from 'vue-property-decorator';
import { currentUserHasPermission } from '@/helpers';
import { matchesAllWords } from '@/helpers/textSearch';
import { Rule, RuleEvent } from '@/types';

@Component
export default class Rules extends Vue {
  loading = true

  searchFilter = ''

  headers = [
    {
      text: 'ID', value: 'id', width: '80px',
    },
    {
      text: 'Nome', value: 'name',
    },
    {
      text: 'Evento', value: 'event',
    },
    {
      text: 'Attiva', value: 'isActive', width: '100px', sortable: false,
    },
    {
      text: '', value: 'actions', width: '200px', sortable: false,
    },
  ]

  get filteredRules(): Rule[] {
    const rules: Rule[] = this.$store.getters.rules || [];

    return rules.filter((rule) => matchesAllWords(this.searchFilter, [rule.id, rule.name]));
  }

  get events(): RuleEvent[] {
    return this.$store.getters.ruleEvents || [];
  }

  eventName(codename: string): string {
    const event = this.events.find((e: RuleEvent) => e.codename === codename);
    return event ? event.name : codename;
  }

  eventChipColor(codename: string): string {
    if (codename === 'lead.created') return 'light-blue lighten-4';
    if (codename === 'lead.updated') return 'orange lighten-4';
    if (codename.startsWith('time.')) return 'green lighten-4';
    return 'grey lighten-3';
  }

  eventChipTextColor(codename: string): string {
    if (codename === 'lead.created') return 'light-blue darken-3';
    if (codename === 'lead.updated') return 'orange darken-3';
    if (codename.startsWith('time.')) return 'green darken-3';
    return 'grey darken-2';
  }

  hasPermission(codename: string): boolean {
    return currentUserHasPermission(codename);
  }

  onToggle(item: Rule) {
    this.$store.dispatch('toggleRule', { id: item.id });
  }

  editRule(item: Rule) {
    this.$router.push(`/r/${item.id}`);
  }

  // Pagina del log delle esecuzioni filtrata sulla regola (e sugli errori)
  openExecutions(item: Rule, onlyErrors: boolean) {
    const query: Record<string, string> = { regola: String(item.id) };
    if (onlyErrors) query.esito = 'error';
    this.$router.push({ path: '/r/esecuzioni', query });
  }

  rowClass(item: Rule): string {
    if (this.$route.query.hl && String(item.id) === String(this.$route.query.hl)) {
      return 'amber lighten-4';
    }
    return '';
  }

  async created() {
    // eslint-disable-next-line no-console
    console.log('Rules: created()');

    try {
      await Promise.all([
        this.$store.dispatch('fetchRules'),
        this.$store.dispatch('fetchRuleMetadata'),
      ]);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Rules: error fetching rules', error);
    } finally {
      this.loading = false;
    }
  }
}
